import { Stack, Switch, Typography } from '@mui/material';
import type { ChangeEvent } from 'react';

export interface PaymentProviderHeaderProps {
    title: string;
    enabled: boolean;
    allowEnable: boolean;
    onToggle: (_: ChangeEvent<HTMLInputElement>, value: boolean) => void;
    onLabel: string;
    offLabel: string;
}

export const PaymentProviderHeader = ({
    title,
    enabled,
    allowEnable,
    onToggle,
    onLabel,
    offLabel,
}: PaymentProviderHeaderProps) => {
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
        >
            <Typography fontWeight={600}>{title}</Typography>

            <Switch
                checked={enabled}
                onChange={onToggle}
                sx={{
                    '& .MuiSwitch-switchBase': {
                        cursor: allowEnable ? 'pointer' : 'not-allowed',
                    },
                    '&& .MuiSwitch-track': {
                        '&:before': {
                            left: '10px',
                            content: `"${onLabel}"`,
                        },
                        '&:after': {
                            right: '12px',
                            content: `"${offLabel}"`,
                        },
                    },
                }}
            />
        </Stack>
    );
};
